<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15" v-if="dataext">
      <v-card>
        <v-card-title class="primary--text text-uppercase">
          {{ $t("fchart.mod_o") }}<br />
          {{ $t("fchart.def_choise") }} {{ datachart.family_name }}
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="obs" v-slot="{ invalid, validate, handleSubmit }">
            <v-form ref="form">
              <v-expansion-panels accordion focusable popout>
                <v-expansion-panel class="mt-5">
                  <v-expansion-panel-header class="info">{{ $t("fchart.mod_o_prt-a") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row :key="stat.id" v-for="stat in filteredStatementsA" class="mt-5">
                      <v-col cols="8">
                        <div v-if="datachart.chart_lang === 'nl'">{{ stat.statement }}</div>
                        <div v-if="datachart.chart_lang === 'en'">{{ stat.statement_en }}</div>
                      </v-col>
                      <v-col>
                        <BaseValSelect v-if="stat.id === 1" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_a" />
                        <BaseValSelect v-if="stat.id === 2" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_b" />
                        <BaseValSelect v-if="stat.id === 3" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_c" />
                        <BaseValSelect v-if="stat.id === 4" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_d" />
                        <BaseValSelect v-if="stat.id === 5" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_e" />
                        <BaseValSelect v-if="stat.id === 6" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_f" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="mt-5">
                  <v-expansion-panel-header class="info">{{ $t("fchart.mod_o_prt-b") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row :key="stat.id" v-for="stat in filteredStatementsB" class="mt-5">
                      <v-col cols="8">
                        <div v-if="datachart.chart_lang === 'nl'">{{ stat.statement }}</div>
                        <div v-if="datachart.chart_lang === 'en'">{{ stat.statement_en }}</div>
                      </v-col>
                      <v-col>
                        <BaseValSelect v-if="stat.id === 7" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_g" />
                        <BaseValSelect v-if="stat.id === 8" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_h" />
                        <BaseValSelect v-if="stat.id === 9" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_i" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="mt-5">
                  <v-expansion-panel-header class="info">{{ $t("fchart.mod_o_prt-c") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row :key="stat.id" v-for="stat in filteredStatementsC" class="mt-5">
                      <v-col cols="8">
                        <div v-if="datachart.chart_lang === 'nl'">{{ stat.statement }}</div>
                        <div v-if="datachart.chart_lang === 'en'">{{ stat.statement_en }}</div>
                      </v-col>
                      <v-col>
                        <BaseValSelect v-if="stat.id === 10" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_j" />
                        <BaseValSelect v-if="stat.id === 11" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_k" />
                        <BaseValSelect v-if="stat.id === 12" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_l" />
                        <BaseValSelect v-if="stat.id === 13" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_m" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="mt-5">
                  <v-expansion-panel-header class="info">{{ $t("fchart.mod_o_prt-d") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row :key="stat.id" v-for="stat in filteredStatementsD" class="mt-5">
                      <v-col cols="8">
                        <div v-if="datachart.chart_lang === 'nl'">{{ stat.statement }}</div>
                        <div v-if="datachart.chart_lang === 'en'">{{ stat.statement_en }}</div>
                      </v-col>
                      <v-col>
                        <BaseValSelect v-if="stat.id === 14" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_n" />
                        <BaseValSelect v-if="stat.id === 15" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_o" />
                        <BaseValSelect v-if="stat.id === 16" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_p" />
                        <BaseValSelect v-if="stat.id === 17" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_q" />
                        <BaseValSelect v-if="stat.id === 18" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_r" />
                        <BaseValSelect v-if="stat.id === 19" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_s" />
                        <BaseValSelect v-if="stat.id === 20" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_t" />
                        <BaseValSelect v-if="stat.id === 21" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_u" />
                        <BaseValSelect v-if="stat.id === 22" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_v" />
                        <BaseValSelect v-if="stat.id === 23" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_w" />
                        <BaseValSelect v-if="stat.id === 24" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_x" />
                        <BaseValSelect v-if="stat.id === 25" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_y" />
                        <BaseValSelect v-if="stat.id === 26" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_z" />
                        <BaseValSelect v-if="stat.id === 27" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_za" />
                        <BaseValSelect v-if="stat.id === 28" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_zb" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="mt-5">
                  <v-expansion-panel-header class="info">{{ $t("fchart.mod_o_prt-e") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row :key="stat.id" v-for="stat in filteredStatementsE" class="mt-5">
                      <v-col cols="8">
                        <div v-if="datachart.chart_lang === 'nl'">{{ stat.statement }}</div>
                        <div v-if="datachart.chart_lang === 'en'">{{ stat.statement_en }}</div>
                      </v-col>
                      <v-col>
                        <BaseValSelect v-if="stat.id === 29" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_zc" />
                        <BaseValSelect v-if="stat.id === 30" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_zd" />
                        <BaseValSelect v-if="stat.id === 31" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_ze" />
                        <BaseValSelect v-if="stat.id === 32" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_zf" />
                        <BaseValSelect v-if="stat.id === 33" rules="required" :items="$t('defchart.items')" item-text="label" item-value="value" v-model="dataext.stat_zg" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div class="text-end mr-15 mt-15">
                <v-btn color="accent" @click="closeItem" class="mr-8">{{ $t("crud.close") }} </v-btn>
                <v-btn color="primary" @click="handleSubmit(saveItem)" :disabled="invalid || !validate">{{ $t("crud.change") }} </v-btn>
              </div>
            </v-form>
          </ValidationObserver>
          <FlashMessage :error="error" v-if="error" key="error" />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import { ValidationObserver } from "vee-validate";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import FchartStatementService from "@/services/fchart/FchartStatementService";
import FchartDefService from "@/services/fchart/FchartDefService";
import FchartService from "@/services/fchart/FchartService";
import BaseValSelect from "@/components/input/BaseValSelect";
export default {
  name: "Users",
  components: {
    BaseValSelect,
    FlashMessage,
    ValidationObserver,
    ToolbarAuth,
    Navigation,
  },
  data() {
    return {
      error: null,
      dataext: {
        stat_a: "",
        stat_b: "",
      },
      datachart: {},
      statements: [],
      model: [0, 1],
    };
  },
  methods: {
    getStatements() {
      this.loading = true;
      FchartStatementService.getOStatements()
        .then((response) => {
          this.statements = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    getData() {
      let Id = this.$route.params.famId;
      this.loading = true;
      FchartDefService.getDefO(Id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },
    getData2() {
      let id = this.$route.params.famId;
      this.loading = true;
      FchartService.getMain(id)
        .then((response) => {
          this.datachart = response.data.data;
        })
        .finally(() => (this.loading = false));
    },
    saveItem() {
      let Id = this.$route.params.famId;
      const payload = {
        stat_a: this.dataext.stat_a,
        stat_b: this.dataext.stat_b,
        stat_c: this.dataext.stat_c,
        stat_d: this.dataext.stat_d,
        stat_e: this.dataext.stat_e,
        stat_f: this.dataext.stat_f,
        stat_g: this.dataext.stat_g,
        stat_h: this.dataext.stat_h,
        stat_i: this.dataext.stat_i,
        stat_j: this.dataext.stat_j,
        stat_k: this.dataext.stat_k,
        stat_l: this.dataext.stat_l,
        stat_m: this.dataext.stat_m,
        stat_n: this.dataext.stat_n,
        stat_o: this.dataext.stat_o,
        stat_p: this.dataext.stat_p,
        stat_q: this.dataext.stat_q,
        stat_r: this.dataext.stat_r,
        stat_s: this.dataext.stat_s,
        stat_t: this.dataext.stat_t,
        stat_u: this.dataext.stat_u,
        stat_v: this.dataext.stat_v,
        stat_w: this.dataext.stat_w,
        stat_x: this.dataext.stat_x,
        stat_y: this.dataext.stat_y,
        stat_z: this.dataext.stat_z,
        stat_za: this.dataext.stat_za,
        stat_zb: this.dataext.stat_zb,
        stat_zc: this.dataext.stat_zc,
        stat_zd: this.dataext.stat_zd,
        stat_ze: this.dataext.stat_ze,
        stat_zf: this.dataext.stat_zf,
        stat_zg: this.dataext.stat_zg,

      };
      this.error = null;
      FchartDefService.postDefO(Id, payload)
        .then(() => {
          let id = this.$route.params.famId;
          this.ok = true;
          this.$router.replace({
            name: "fchartDef",
            params: { famId: id },
          });
        })
        .catch((error) => (this.error = getError(error)))
        .finally(() => {
          // eslint-disable-next-line no-undef
          EventBus.$emit("succes", true);
        });
    },

    closeItem() {
      let id = this.$route.params.famId;
      this.$router.replace({
        name: "fchartDef",
        params: { famId: id },
      });
    },
  },
  // watch: {
  //   "dataext.stat_v": function () {
  //     if (this.dataext.stat_v === "ke2") {
  //       this.dataext.stat_w = "ke4";
  //       this.dataext.stat_x = "ke4";
  //       this.dataext.stat_y = "ke4";
  //       this.dataext.stat_z = "ke4";
  //     }
  //   },
  // },

  computed: {
    filteredStatementsA() {
      return this.statements.slice(0, 6);
    },
    filteredStatementsB() {
      return this.statements.slice(6, 9);
    },
    filteredStatementsC() {
      return this.statements.slice(9, 13);
    },
    filteredStatementsD() {
      return this.statements.slice(13, 28);
    },
    filteredStatementsE() {
      return this.statements.slice(28, 33);
    },
    

  },
  created() {
    this.getData();
    this.getStatements();
    this.getData2();
  },
};
</script>

<style scoped></style>
